module.exports = __webpack_public_path__ + "img/close-circle.deddecb3.svg";